import type { IconDefinition } from '../index.tsx';

export const iconArrowUpRight: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconArrowUpRight',
  icon: [
    16,
    16,
    [],
    '',
    'M5.81278 1.45532L8.72341 4.36595L0 12.9422L2.91064 15.8528L11.634 7.27659L14.5447 10.1872L16 8.7319L16 4.90696e-06L7.2681 0L5.81278 1.45532Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
